/**
 * 必传：title ,tableList,modalClass,code,urlApi
 * 选传：
 *      hasStatus 请求时是否需要传参 status 值为1
 *      showCode  下拉展示的code字段  不传默认展示code字段
 *      showName  下拉展示的name字段  不传默认展示name字段
 *      isDouble  弹窗中是否存在一个单元格展示两个字段，配合tableList 可参考buyerInfo
 *      isSm      弹窗大小
*/
module.exports = {
    carType: {
        title: '车辆类型',
        tableList: [
            { name: '车辆种类代码', keywords: 'code' },
            { name: '车辆大类名称', keywords: 'classname' },
            { name: '车辆种类名称', keywords: 'name' },
        ],
        modalClass: 'mod-modal mod-modal-lg',
        code: 'carType',
        isSm: true,
        urlApi: 'post_getVehicleTypeList',
    },
    field: {
        title: '产地',
        tableList: [
            { name: '产地名称', keywords: 'name' },
            { name: '产地代码', keywords: 'code' },
            { name: '产地简称', keywords: 'briefname' },
        ],
        modalClass: 'mod-modal mod-modal-lg',
        code: 'field',
        isSm: true,
        urlApi: 'post_getVehicleOriginList',
    },
    carInfo: {
        title: '车辆信息',
        tableList: [
            { name: '编码', keywords: 'code' },
            { name: '车辆类型', keywords: 'vehicleType' },
            { name: '厂牌型号', keywords: 'brandmode' },
            { name: '产地', keywords: 'place' },
            { name: '生产企业名称', keywords: 'enterpriseName' },
            { name: '税收合并编码', keywords: 'taxMergeCode' },
            { name: '是否享受优惠政策', keywords: 'isPrivilege' },
            { name: '优惠政策类型', keywords: 'privilegeType' },
            { name: '税率', keywords: 'taxRate' },
            { name: '数据类型', keywords: 'dataShare' },
        ],
        modalClass: 'mod-modal mod-modal-hg',
        code: 'carInfo',
        hasStatus: true,
        showName: 'vehicleType',
        urlApi: 'post_pageVehicleGood',
    },
    goodsInfo: {
        title: '商品信息',
        tableList: [
            { name: '编码', keywords: 'goodsCode' },
            { name: '名称', keywords: 'goodsName' },
            { name: '规格型号', keywords: 'specifications' },
            { name: '税率', keywords: 'taxRate' },
            { name: '计量单位', keywords: 'measureUnit' },
            { name: '单价', keywords: 'price' },
            { name: '含税标识', keywords: 'taxInclud' },
            { name: '税收分类编码', keywords: 'taxMergeCode' },
            { name: '是否享受优惠政策', keywords: 'isPrivilege' },
            { name: '优惠政策类型', keywords: 'privilegeType' },
            { name: '数据类型', keywords: 'dataShare' },
        ],
        modalClass: 'mod-modal mod-modal-hg',
        code: 'goodsInfo',
        hasStatus: true,
        showCode: 'goodsCode',
        showName: 'goodsName',
        urlApi: 'post_pageGoodsInfo',
    },
    buyerInfo: {
        title: '购方信息',
        tableList: [
            { name: '编码', keywords: ['customerCode'] },
            { name: '名称', keywords: ['customerName'] },
            { name: '纳税人识别号', keywords: ['creditCode'] },
            { name: '地址电话', keywords: ['businessAddress', 'phone'] },
            { name: '银行账号', keywords: ['bank', 'bankAccount'] },
            { name: '身份证号码/组织机构代码', keywords: ['certificateNo'] },
        ],
        modalClass: 'mod-modal mod-modal-hg',
        code: 'buyerInfo',
        isDouble: true,
        hasStatus: true,
        urlApi: 'post_getPageCustomerList',
    },
    buyerName: {
        title: '购方信息',
        tableList: [
            { name: '编码', keywords: ['customerCode'] },
            { name: '名称', keywords: ['customerName'] },
            { name: '纳税人识别号', keywords: ['creditCode'] },
            { name: '地址电话', keywords: ['businessAddress', 'phone'] },
            { name: '银行账号', keywords: ['bank', 'bankAccount'] },
            { name: '身份证号码/组织机构代码', keywords: ['certificateNo'] },
        ],
        modalClass: 'mod-modal mod-modal-hg',
        code: 'buyerInfo',
        isDouble: true,
        hasStatus: true,
        urlApi: 'post_qryByCodeOrName',
    },
    manufacturerName: {
        title: '生产企业名称',
        tableList: [
            { name: '生产企业代码', keywords: 'code' },
            { name: '产地代码', keywords: 'productcode' },
            { name: '生产企业名称', keywords: 'name' },
            { name: '生产企业简称', keywords: 'briefname' },
            { name: '主管税务机关代码', keywords: 'directortaxcode' },
        ],
        modalClass: 'mod-modal mod-modal-hg',
        code: 'manufacturerName',
        urlApi: 'post_getSysVehicleCompanyList',
    },
}



// WEBPACK FOOTER //
// ./src/components/popupSelect2/config.js